<div class="page-container">
    <div class="flex items-center justify-between">
      <h1 class="main-heading">Receipt</h1>
      <app-navpath />
    </div>
  
    <ul class="tabs-container">
      <li (click)="selectedTab = 'buyers'" [ngClass]="selectedTab === 'buyers' ? 'tab-item_selected' : 'tab-item'">
        Buyers Receipt
      </li>
      <li (click)="selectedTab = 'deposit'" [ngClass]="selectedTab === 'deposit' ? 'tab-item_selected' : 'tab-item'">
        Deposit Receipt
      </li>
    </ul>
  
    <!-- Buyer's Receipt Tab -->
<section class="content-container__tabs" [hidden]="selectedTab !== 'buyers'">
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Search receipt</h2>
    <app-data-form 
      [dataFields]="searchForm" 
      [dataName]="'searchForm'"
      (clickSearch)="searchBuyers($event)"
      (updateFields_child)="updateSearchReceipt($event)"
    />
  </div>

  <div class="content-container" *ngIf="showTransferSection">
    <h2 class="sub-heading w-full border-b">Transfer Receipt</h2>
    <app-data-form
      [dataFields]="transferReceiptForm"
      [dataName]="'transferReceiptForm'"
    ></app-data-form>
    <div class="mt-4 flex w-fit gap-1">
      <button class="shorter-btn misc-btn" (click)="transferReceipt()">
        <fa-icon [icon]="faPencil" class="mr-1" />Transfer
      </button>
      <button class="shorter-btn clear-btn" (click)="cancelTransferReceipt()">
        <fa-icon [icon]="faBan" class="mr-1" />Cancel
      </button>
    </div>
  </div>  

  <label class="my-4 flex items-center justify-end gap-3">
    Transfer Receipt
    <label class="switch">
      <input
        type="checkbox"
        [(ngModel)]="isTransfer"
        (change)="handleTransferToggle()"
      />
      <span class="slider round"></span>
    </label>
  </label>
  
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Details Of Buyer</h2>
    <app-data-form [dataFields]="buyerDetailsForm" [dataName]="'buyerDetailsForm'" [columns]="2" />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Details Of Buyer's Receipt</h2>
    <app-data-form 
      [dataFields]="buyerReceiptForm" 
      [dataName]="'buyerReceiptForm'" 
      (updateFields_child)="updateDetails($event)" />
  </div>

  <div class="content-container">
    <div class="mt-4 flex w-fit gap-1">
      <button class="shorter-btn misc-btn" (click)="addReceipt()">
        <fa-icon [icon]="faPlus" class="mr-1" />Add New Receipt
      </button>
      <button class="shorter-btn misc-btn" (click)="updateReceipt()">
        <fa-icon [icon]="faPencil" class="mr-1" />Update
      </button>
      <button class="shorter-btn delete-btn" (click)="deleteReceipt()">
        <fa-icon [icon]="faTrash" class="mr-1" />Delete
      </button>
      <button class="shorter-btn misc-btn" (click)="printReceipt()">
        <fa-icon [icon]="faPrint" class="mr-1" />Print
      </button>
      <button class="shorter-btn clear-btn" (click)="clearReceipt()">
        <fa-icon [icon]="faBan" class="mr-1" />Clear
      </button>
      <button class="shorter-btn misc-btn" (click)="sendReceiptEmail()">
        <fa-icon [icon]="faEnvelope" class="mr-1" />Send Email
      </button>
    </div>
    <app-data-table
      class="block mt-4"
      [tableHeaders]="tableReceiptHeaders"
      [tableEntries]="tableReceiptEntries"
      (edit)="editReceipt($event)"
    ></app-data-table>
  </div>
</section>
<div class="modal" *ngIf="showDeleteModal">
  <div class="modal-backdrop"></div>
  <div class="modal-content shadow-lg">
    <h3 class="font-bold mb-4">Delete Receipt</h3>
    <label class="block mb-2">Delete Remarks</label>
    <input
      type="text"
      class="form-input w-full mb-4"
      [(ngModel)]="deleteRemarks"
      placeholder="Enter reason"
    />
    <div class="flex justify-end gap-2">
      <button class="btn btn-primary" (click)="confirmDeleteReceipt()">Delete</button>
      <button class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
    </div>
  </div>
</div>

<!-- Deposit Receipt Tab -->
<section class="content-container__tabs" [hidden]="selectedTab !== 'deposit'">
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Search</h2>
    <app-data-form 
      [dataFields]="depositSearchForm" 
      [dataName]="'depositSearchForm'" 
      (clickSearch)="searchDeposit($event)"/>
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Details Of Buyer</h2>
    <app-data-form [dataFields]="depositBuyerDetailsForm" [dataName]="'depositBuyerDetailsForm'" [columns]="2" />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Details Of Buyer's Deposit Receipt</h2>
    <app-data-form [dataFields]="depositSummaryForm" [dataName]="'depositSummaryForm'" />
  </div>

  <div class="content-container">
    <app-data-table
      class="block mt-4"
      [tableHeaders]="depositTableHeaders"
      [tableEntries]="depositTableEntries"
    ></app-data-table>
  </div>
</section>


  </div>
  